<template>
    <el-table :data="data" :default-sort="{ prop: 'searchTimestamp', order: 'descending' }" empty-text="No order searches to display" class="w-100">
        <el-table-column label="Order Id" prop="id"> </el-table-column>
        <el-table-column label="Placed By" prop="email"> </el-table-column>
        <el-table-column label="Placed On" prop="createdAt">
            <template slot-scope="scope">
                {{ `${getCreatedDate(scope.row[ORDERS.fields.createdAt])}` }}
            </template>
        </el-table-column>
        <el-table-column align="right">
            <template slot-scope="scope">
                <router-link :to="{ path: `/portal/orders/${scope.row.id}` }" class="btn btn-sm btn-primary">
                    Open
                </router-link>
            </template>
        </el-table-column>
    </el-table>
</template>
<script>
import { ORDERS } from 'db'
export default {
    props: {
        data: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            ORDERS
        }
    },
    methods: {
        getCreatedDate(date) {
            return new Date(date).toLocaleString('en-US', {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric'
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.el-table table .btn {
    margin: 0 5px;
}
</style>
